import {HistoryBridge} from '../historyBridge';
import {createBridgeCaller} from '../BridgeApi';
import {createClassLogger, Logger} from '../../utils/Logging';

const BRIDGE_NAME = 'history';
const logger: Logger = createClassLogger('HistoryBridge:Launcher');
const executeHistoryBridgeCall = createBridgeCaller(BRIDGE_NAME, logger);

const historyLauncher: HistoryBridge = {
    pushUrlHistory: (url: string): Promise<void> =>
        executeHistoryBridgeCall('pushurlhistory', [url]),

    replaceUrlHistory: (url: string): Promise<void> =>
        executeHistoryBridgeCall('replaceurlhistory', [url]),

    refresh: (): Promise<void> => executeHistoryBridgeCall('refresh')
};

export default historyLauncher;
